// Texts of the stream page and the edit panel (UIC-2 + FCE-3,
// docs/design/ui-one-console.md §4.3, docs/design/fls-control-edit.md).
// Glossary: docs/design/i18n.md ("поток" - stream, "площадка" - site).

import { defineMessages } from '@/shared/i18n'

export const messages = defineMessages({
  ru: {
    title: 'Поток',
    back: 'Потоки',
    loading: 'Загрузка…',
    missing: 'Поток «{name}» не найден.',
    comes: 'приходит: {origin}',
    noInput: 'входа нет',
    newStream: 'Новый поток',
    createDenied: 'Создать поток на этой площадке нельзя: нужен уровень правки edit на площадке и роль engineer.',

    // header
    watch: 'Смотреть',
    archive: 'Архив ↗',
    openUi: 'Открыть в UI Flussonic ↗',
    edit: 'Изменить',
    manage: 'Управлять',
    advanced: 'Расширенная форма',
    restart: 'Перезапустить',
    stop: 'Остановить',
    unstop: 'Снять остановку',
    level_off: 'правка выключена',
    level_ops: 'правка: ops',
    level_edit: 'правка: edit',
    level_backend: 'бэкенд сайта',
    level_offline: 'площадка не на связи',
    noteOff: 'Правка из пульта на этой площадке выключена (flussonic_api.control_edit.mode: off в agent.yaml). Остановить и перезапустить поток можно.',
    noteBackend: 'Заведено бэкендом сайта ({actor}). Пульт поток только показывает: не правит и не включает/выключает, бэкенд всё равно перезапишет правку.',
    noteOffline: 'Площадка не на связи: правка из пульта недоступна, пока агент не вернётся.',
    noteRole: 'Для правки этого потока нужна роль {role}.',
    editUnavailable: 'Правка из пульта недоступна',
    heldBy: 'Поток остановлен из пульта ({actor}).',

    // columns
    colFrom: 'Откуда',
    colDo: 'Что делаем',
    colTo: 'Куда',
    addInput: '+ Вход',
    addDest: '+ Назначение',
    noInputs: 'Входов нет.',
    noDests: 'Назначений нет.',
    nowOn: 'сейчас горит',
    inputOff: 'выключен',
    inputReady: 'готов',
    inputWaits: 'ждёт',
    inPublish: 'к нам шлют SRT',
    inSlate: 'заставка',
    portOpen: 'порт открыт',
    portClosed: 'порт закрыт',
    passphraseSet: 'пароль ••••',
    openPort: 'Открыть порт',
    closePort: 'Закрыть порт',
    openStream: 'открыть {name}',
    putOn: 'В эфир',
    takeOff: 'Снять с эфира',
    pushOff: 'снят',
    takers: 'Берут этот поток',
    viaChannel: 'канал пульта',
    doReserve: 'Резерв',
    doOneInput: 'один вход',
    doReserveN: {
      one: '{count} резервный вход',
      few: '{count} резервных входа',
      many: '{count} резервных входов',
      other: '{count} резервного входа',
    },
    doArchive: 'Архив',
    doArchiveOn: 'пишется',
    doTranscode: 'Перекод',
    doTranscodeOn: 'есть',
    doSlate: 'Заставка',
    doSlateOn: 'есть',
    doNone: 'нет',
    hours: { one: '{n} час', few: '{n} часа', many: '{n} часов', other: '{n} часа' },

    // tabs
    tab_preview: 'Превью',
    tab_alarms: 'Алармы',
    tab_history: 'История изменений',
    tab_json: 'Документ (JSON)',
    noPreview: 'Превью нет: поток не идёт или у площадки нет адреса UI Flussonic.',
    noFrame: 'Кадра пока нет.',
    play: 'Смотреть вживую',
    closePlayer: 'Закрыть плеер',
    previewInAdvanced: 'Превью со звуком и метрами — в расширенной форме канала →',
    noAlarms: 'Алармов нет.',
    allAlarms: 'Все алармы →',
    jsonMeta: 'Ревизия {rev} · {actor} · {time} · {status}',
    jsonMasked: 'Ключи и пароли замаскированы агентом: пульт их не хранит.',
    historyEmpty: 'Истории нет.',
    historyHint: 'История хранится на агенте (20 последних ревизий). Правки из UI Flussonic, бэкенда сайта и пульта лежат в одном списке.',
    historyUnavailable: 'История недоступна: правка из пульта на площадке не включена.',
    hRevision: 'Ревизия',
    hWho: 'Кто',
    hWhen: 'Когда',
    hWhat: 'Что изменилось',
    hAction: 'Действие',
    revCreated: 'создан',
    revDeleted: 'удалён',
    revertTo: 'Вернуть эту версию',
    revertTitle: 'Вернуть ревизию {rev}?',
    revertBody: 'Документ потока станет таким, каким был в этой ревизии. Агент проверит его так же, как обычную правку.',

    // toast
    toastSaved: 'Сохранено (ревизия {rev})',
    toastCreated: 'Поток «{name}» создан',
    toastDeleted: 'Поток «{name}» удалён',
    toastUndone: 'Отменено: новая ревизия {rev}',
    toastUndoneShort: 'Отменено',
    toastTakenOff: '«{name}» снято с эфира',
    toastPutOn: '«{name}» в эфире',
    undo: 'Отменить',
    dismiss: 'Закрыть',

    // restart / stop
    restartTitle: 'Перезапустить поток {name}?',
    restartBody: 'Агент переподключит пуши потока и перезапустит его входы.',
    stopTitle: 'Остановить поток {name}?',
    stopBody: 'Поток будет держаться выключенным, что бы ни записал в него клиент API.',
    unstopTitle: 'Снять остановку потока {name}?',
    unstopBody: 'Поток вернётся к тому, что записано в его документе.',
    stopReason: 'Причина (в журнал)',

    // panel
    editTitle: 'Правка потока',
    editOf: 'Правка: {name}',
    levelOps: 'ops',
    levelEdit: 'edit',
    close: 'Закрыть',
    cancel: 'Отмена',
    opsNote: 'Уровень площадки ops: можно включать и выключать поток, пуши и входы. Адреса, ключи, архив и новые входы — уровень edit (agent.yaml площадки).',
    revNote: 'Ревизия {rev} · последний автор {actor}. Правка уходит агенту командой; агент проверяет и записывает.',
    modeForm: 'Форма',
    modeJson: 'JSON (эксперт)',
    jsonLabel: 'Документ потока',
    jsonHint: 'Весь документ с масками. Маска *** оставляет прежнее значение; новые ключи в этом режиме не вводятся.',
    fName: 'Имя потока',
    fTitle: 'Подпись',
    fWorks: 'Поток работает',
    fAddress: 'Адрес',
    fInputOff: 'вход выключен (порт закрыт)',
    fPort: 'Порт SRT',
    fPassphrase: 'Пароль (passphrase)',
    fKey: 'Ключ',
    fPushOn: 'в эфире',
    fArchive: 'Архив, часов',
    archiveNone: 'нет',
    archiveHint: 'Глубина архива. Диск и хранилище задаются в UI Flussonic.',
    keepPlaceholder: '•••• — пусто = оставить как был',
    addPublish: '+ К нам шлют (SRT)',
    addCopy: '+ Берём с потока (copy://)',
    addPushEmpty: '+ Назначение',
    pasteInput: 'Вставьте ссылку: copy://…, srt://…, https://….m3u8',
    pastePush: 'Вставьте ссылку: rtmp://хост/приложение/ключ, srt://…',
    addFromLink: 'Добавить по ссылке',
    pasteMiss: 'Это не похоже на ссылку потока.',
    up: 'Выше',
    down: 'Ниже',
    remove: 'Убрать',
    reason: 'Заметка в журнал (необязательно)',
    willChange: 'Что изменится',
    nothingChanged: 'Ничего не изменено.',
    secretChanged: '{field}: новое значение (скрыто)',
    needEdit: '{field}: нужен уровень edit на площадке',
    check: 'Проверить',
    save: 'Сохранить',
    create: 'Создать',
    delete: 'Удалить',
    keysStay: 'ключи остаются на агенте',
    deleteTitle: 'Удалить поток {name}?',
    deleteBody: 'Агент хранит историю удалённого потока 7 дней: его можно будет восстановить.',
    checkTitle: 'Проверка на агенте (ничего не записано)',
    checkOk: 'Агент принимает такую правку.',
    ingressOpen: '{proto} {port}: порт откроется',
    ingressClose: '{proto} {port}: порт закроется',
    storedOnly: '{field}: сохранится, но не исполняется',
    problem_json: 'это не JSON-объект',
    problem_name: 'имя: буквы, цифры, _ - . /',
    problem_key_required: 'введите ключ заново (адрес изменился)',
    problem_url_empty: 'адрес не заполнен',
    problem_port: 'порт от 1 до 65535',
    problem_dvr: 'глубина архива — положительное число часов',
    problem_passphrase_short: 'пароль от 10 до 79 символов',

    // conflict
    conflictTitle: 'Пока вы правили, поток изменили.',
    conflictWho: '{actor} · ревизия {from} → {to}',
    conflictBoth: 'Одни и те же поля изменены с обеих сторон: {fields}. Наложить автоматически нельзя.',
    conflictExists: 'Поток с таким именем уже есть на площадке.',
    takeTheirs: 'Взять их версию',
    overlayMine: 'Наложить мои изменения на их версию',

    // failures
    fail_conflict: 'Поток изменили, пока вы правили.',
    fail_level: 'Агент не разрешает эту правку на текущем уровне площадки.',
    fail_backend_owned: 'Поток заведён бэкендом сайта: из пульта он не правится.',
    fail_invalid: 'Агент не принял правку:',
    fail_rate: 'Слишком много правок за минуту, подождите.',
    fail_precondition: 'Запрос без ревизии: обновите страницу.',
    fail_ha_unclear: 'Пара площадки в неясном состоянии: правка запрещена, пока не ясно, какой узел активен.',
    fail_offline: 'Агент площадки не на связи: правка не поставлена в очередь.',
    fail_unavailable: 'Правка из пульта недоступна на площадке: агент без правки потоков или control её ещё не обслуживает.',
    fail_timeout: 'Агент не ответил вовремя: неизвестно, применилась ли правка. Проверьте ревизию потока.',
    fail_forbidden: 'Нет прав на это действие.',
    fail_not_found: 'Поток не найден.',
    fail_other: 'Не удалось:',
  },
  en: {
    title: 'Stream',
    back: 'Streams',
    loading: 'Loading…',
    missing: 'Stream "{name}" not found.',
    comes: 'comes in: {origin}',
    noInput: 'no input',
    newStream: 'New stream',
    createDenied: 'A stream cannot be created on this site: it needs the edit level on the site and the engineer role.',

    watch: 'Watch',
    archive: 'Archive ↗',
    openUi: 'Open in Flussonic UI ↗',
    edit: 'Edit',
    manage: 'Manage',
    advanced: 'Advanced form',
    restart: 'Restart',
    stop: 'Stop',
    unstop: 'Lift the stop',
    level_off: 'editing is off',
    level_ops: 'editing: ops',
    level_edit: 'editing: edit',
    level_backend: 'site backend',
    level_offline: 'site offline',
    noteOff: 'Editing from the console is off on this site (flussonic_api.control_edit.mode: off in agent.yaml). You can still stop and restart the stream.',
    noteBackend: 'Created by the site backend ({actor}). The console only shows the stream: it does not edit it or switch it on and off, the backend would overwrite the change anyway.',
    noteOffline: 'The site is offline: editing from the console is unavailable until the agent is back.',
    noteRole: 'Editing this stream needs the {role} role.',
    editUnavailable: 'Editing from the console is unavailable',
    heldBy: 'The stream is stopped from the console ({actor}).',

    colFrom: 'From',
    colDo: 'What we do',
    colTo: 'To',
    addInput: '+ Input',
    addDest: '+ Destination',
    noInputs: 'No inputs.',
    noDests: 'No destinations.',
    nowOn: 'on air now',
    inputOff: 'off',
    inputReady: 'ready',
    inputWaits: 'waiting',
    inPublish: 'sent to us over SRT',
    inSlate: 'slate',
    portOpen: 'port open',
    portClosed: 'port closed',
    passphraseSet: 'password ••••',
    openPort: 'Open the port',
    closePort: 'Close the port',
    openStream: 'open {name}',
    putOn: 'Put on air',
    takeOff: 'Take off air',
    pushOff: 'off',
    takers: 'Taking this stream',
    viaChannel: 'console channel',
    doReserve: 'Reserve',
    doOneInput: 'one input',
    doReserveN: { one: '{count} reserve input', other: '{count} reserve inputs' },
    doArchive: 'Archive',
    doArchiveOn: 'recording',
    doTranscode: 'Transcode',
    doTranscodeOn: 'yes',
    doSlate: 'Slate',
    doSlateOn: 'yes',
    doNone: 'no',
    hours: { one: '{n} hour', other: '{n} hours' },

    tab_preview: 'Preview',
    tab_alarms: 'Alarms',
    tab_history: 'Change history',
    tab_json: 'Document (JSON)',
    noPreview: 'No preview: the stream is not running or the site has no Flussonic UI address.',
    noFrame: 'No frame yet.',
    play: 'Watch live',
    closePlayer: 'Close the player',
    previewInAdvanced: 'Preview with sound and meters is in the channel advanced form →',
    noAlarms: 'No alarms.',
    allAlarms: 'All alarms →',
    jsonMeta: 'Revision {rev} · {actor} · {time} · {status}',
    jsonMasked: 'Keys and passwords are masked by the agent: the console does not keep them.',
    historyEmpty: 'No history.',
    historyHint: 'The history is kept on the agent (the last 20 revisions). Changes from the Flussonic UI, the site backend and the console are in one list.',
    historyUnavailable: 'History is unavailable: editing from the console is not enabled on the site.',
    hRevision: 'Revision',
    hWho: 'Who',
    hWhen: 'When',
    hWhat: 'What changed',
    hAction: 'Action',
    revCreated: 'created',
    revDeleted: 'deleted',
    revertTo: 'Restore this version',
    revertTitle: 'Restore revision {rev}?',
    revertBody: 'The stream document becomes what it was in this revision. The agent checks it like any edit.',

    toastSaved: 'Saved (revision {rev})',
    toastCreated: 'Stream "{name}" created',
    toastDeleted: 'Stream "{name}" deleted',
    toastUndone: 'Undone: new revision {rev}',
    toastUndoneShort: 'Undone',
    toastTakenOff: '"{name}" taken off air',
    toastPutOn: '"{name}" on air',
    undo: 'Undo',
    dismiss: 'Close',

    restartTitle: 'Restart stream {name}?',
    restartBody: 'The agent reconnects the stream pushes and restarts its inputs.',
    stopTitle: 'Stop stream {name}?',
    stopBody: 'The stream is kept off whatever an API client writes to it.',
    unstopTitle: 'Lift the stop of stream {name}?',
    unstopBody: 'The stream returns to what its document says.',
    stopReason: 'Reason (journalled)',

    editTitle: 'Edit stream',
    editOf: 'Edit: {name}',
    levelOps: 'ops',
    levelEdit: 'edit',
    close: 'Close',
    cancel: 'Cancel',
    opsNote: 'Site level ops: you can switch the stream, its pushes and inputs on and off. Addresses, keys, archive and new inputs need the edit level (the site agent.yaml).',
    revNote: 'Revision {rev} · last author {actor}. The change goes to the agent as a command; the agent checks and writes it.',
    modeForm: 'Form',
    modeJson: 'JSON (expert)',
    jsonLabel: 'Stream document',
    jsonHint: 'The whole document with masks. A *** mask keeps the old value; new keys are not typed in this mode.',
    fName: 'Stream name',
    fTitle: 'Title',
    fWorks: 'The stream works',
    fAddress: 'Address',
    fInputOff: 'input off (port closed)',
    fPort: 'SRT port',
    fPassphrase: 'Password (passphrase)',
    fKey: 'Key',
    fPushOn: 'on air',
    fArchive: 'Archive, hours',
    archiveNone: 'none',
    archiveHint: 'Archive depth. The disk and storage are set in the Flussonic UI.',
    keepPlaceholder: '•••• — empty = keep as it was',
    addPublish: '+ Sent to us (SRT)',
    addCopy: '+ Take from a stream (copy://)',
    addPushEmpty: '+ Destination',
    pasteInput: 'Paste a link: copy://…, srt://…, https://….m3u8',
    pastePush: 'Paste a link: rtmp://host/app/key, srt://…',
    addFromLink: 'Add from link',
    pasteMiss: 'This does not look like a stream link.',
    up: 'Up',
    down: 'Down',
    remove: 'Remove',
    reason: 'Note for the journal (optional)',
    willChange: 'What will change',
    nothingChanged: 'Nothing changed.',
    secretChanged: '{field}: new value (hidden)',
    needEdit: '{field}: needs the edit level on the site',
    check: 'Check',
    save: 'Save',
    create: 'Create',
    delete: 'Delete',
    keysStay: 'keys stay on the agent',
    deleteTitle: 'Delete stream {name}?',
    deleteBody: 'The agent keeps the history of a deleted stream for 7 days: it can be restored.',
    checkTitle: 'Checked on the agent (nothing written)',
    checkOk: 'The agent accepts this change.',
    ingressOpen: '{proto} {port}: the port will open',
    ingressClose: '{proto} {port}: the port will close',
    storedOnly: '{field}: stored but not executed',
    problem_json: 'not a JSON object',
    problem_name: 'name: letters, digits, _ - . /',
    problem_key_required: 'type the key again (the address changed)',
    problem_url_empty: 'address is empty',
    problem_port: 'port from 1 to 65535',
    problem_dvr: 'archive depth is a positive number of hours',
    problem_passphrase_short: 'password of 10 to 79 characters',

    conflictTitle: 'The stream was changed while you were editing.',
    conflictWho: '{actor} · revision {from} → {to}',
    conflictBoth: 'The same fields changed on both sides: {fields}. It cannot be overlaid automatically.',
    conflictExists: 'A stream with this name already exists on the site.',
    takeTheirs: 'Take their version',
    overlayMine: 'Overlay my changes on their version',

    fail_conflict: 'The stream was changed while you were editing.',
    fail_level: 'The agent does not allow this change at the site level.',
    fail_backend_owned: 'The stream was created by the site backend: it is not edited from the console.',
    fail_invalid: 'The agent did not accept the change:',
    fail_rate: 'Too many changes per minute, wait a moment.',
    fail_precondition: 'The request had no revision: reload the page.',
    fail_ha_unclear: 'The site pair is in an unclear state: editing is blocked until it is clear which node is active.',
    fail_offline: 'The site agent is offline: the change was not queued.',
    fail_unavailable: 'Editing from the console is unavailable on the site: the agent has no stream editing or control does not serve it yet.',
    fail_timeout: 'The agent did not answer in time: it is unknown whether the change applied. Check the stream revision.',
    fail_forbidden: 'No rights for this action.',
    fail_not_found: 'Stream not found.',
    fail_other: 'Failed:',
  },
})
